<template>
<div>
    <smallbutton :toplabel="titleLabel_short" @click="startAdd()" v-if="showButton" :buttonclass="buttonclass" :disabled="disabled"/>
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                <label class="titlelabel">{{ titleLabel }}</label>
                <br/>
                
                
                <formentry   label="Name"  v-model="currentType.name" :isrequired="trueParam" />
                <formentry   label="Seats Available"  v-model="currentType.seatsAvailable" :isrequired="trueParam" />
     
                  <!-- image -->
                <div class="showProductImage">
                    <br>
                    <br>
                    <div class="personPhoto" v-if="currentType.imageFilename!=null">
                        <img :src="getProductImage"  width="100" class="" >
                    </div>
                    
                    <smallbutton toplabel="Add Image" @Click="addfile" :disabled="currentType.typeId==0" v-if="currentType.imageFilename==null"/>
                    <smallbutton toplabel="Replace Image" @Click="addfile" :disabled="currentType.typeId==0" v-if="currentType.imageFilename!=null"/>
                    <smallbutton toplabel="Edit Image" v-if="currentType.imageFilename!=null" @click="editImage()" />

                    <imagealldoc ref="imgdoc"  fileAccept="*.*"  :allowFileSelect="trueParam" :allowCapture="falseParam" @saveimg="saveimg_document"  :showImage='falseParam' />
                    <imageeditor ref="imgedit" :img="selectedImageURL" @save="saveimg_document"/>
                </div>

                <div>
                    <label class="pleasewait" v-if="pleaseWait">Please Wait...</label>
                </div>
                <smallbutton  @click="save()" toplabel="Save"  buttonclass="button buttonsave"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel" buttonclass="button buttoncancel"/>
                <div>
                    <label class="responsemessage">{{message}}</label>
                </div>
            </form>
            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../services/datamethods.js'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
 import imagealldoc from '../controls/ImageAll.vue'
 import imageeditor from '../controls/ImageEditor.vue'
export default {
    name:'updateseatingtype',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        imagealldoc,
        imageeditor
    },
    props:{
        inType:{
            type:Object,
        },
        isAdd:{
            type:Boolean,
            default:false
        },
        typeName:{
            type:String,
            required:true
        },
        showButton:{
            type:Boolean,
            default:false
        },
        buttonclass:{
          type:String,
          default:"button buttonprimary"
        },
        disabled:{
            type:Boolean,
            default:false
        }
        
    },
    mixins:[format,datamethods],
    data(){
        return{
            pleaseWait:false,
            currentType:{
                id:0,
                name:null,
                isActive:false
            },
            trueParam:true,
            falseParam:false,
            message:null,
            selectedImageURL:null,
        }
    },
    computed:{
        
        titleLabel(){
            if(this.isAdd){return "Add " + this.typeName}
            else{ return "Update " + this.currentType.name  }
        },
        titleLabel_short(){
            if(this.isAdd){return "Add"}
            else{ return "Update"  }
        },
        getProductImage(){
       
            if(this.currentType.imageFilename==null){return null}
                var imgBasePath =  window.VUE_CONFIG_API + 'personimage/'

            var fn = this.currentType.imageFilename
            var splitfn=fn
            const lastDot = fn.lastIndexOf('.');
            if (lastDot > 0) {
                splitfn= fn.slice(0, lastDot) + '/' + fn.slice(lastDot + 1);
            }
            this.selectedImageURL=imgBasePath + splitfn
            return imgBasePath + splitfn
        },
    },
    mounted(){
        
    },
    methods:{
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        
      
        startAdd(){
            this.message=null
           if(this.isAdd){
                this.currentType={
                    id:0,
                    name:null,
                    isActive:false
                }
            }else{
                this.currentType = JSON.parse(JSON.stringify(this.inType)) 
            }
            

            this.$refs.mymodal.openModal()
        },
        async save(){
            if(this.currentType.name==null || this.currentType.name==''){this.message="Please enter a name"; return}
           this.$emit('save',this.currentType)
           this.$refs.mymodal.closeModal()
        },

        addfile(){
            this.$refs.imgdoc.openModal() 
        },
        editImage(){
            this.$nextTick(()=>{
                this.$refs.imgedit.openModal()
            })
        },
        saveimg_document(file,url,typeId){
                    this.storeDocument("doc", file, file.name,typeId)
        },
        
        async storeDocument(filename,file, name,typeId){
            var pId=this.currentType.id
            var postParams = new FormData();

            postParams.append(filename,file,name);
            postParams.append('seatingTypeId',pId);
            postParams.append('name',this.currentType.name);
            postParams.append('seatsAvailable',this.currentType.seatsAvailable);

            this.pleaseWait=true
            var response = await this.callAPI(postParams,'saveseatingtypeimage')
            //handle response
            if(response.Successful){
                //this.RefreshCurrent() 
                this.currentType.imageFilename= response.fileName
                this.currentType.id=response.id
                this.currentType.isActive=true
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false  
        },  
        
       
        
    }
}
</script>

<style>

</style>





























